import { KeyboardEvent, useState } from 'react';
import { classNames } from 'shared/lib/classNames/classNames';
import { ThemeWrapper, Wrapper } from 'shared/ui/Wrapper/Wrapper';
import { useApi } from 'app/api/APIProvider';
import { useDispatch, useSelector } from 'react-redux';
import { getPlotStepData, plotStepData, plotStepsActions } from 'widgets/PlotSteps';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import cls from './BlockSelection.module.scss';

interface BlockSelectionProps {
    className?: string;
}

export const BlockSelection = (props: BlockSelectionProps) => {
    const {
        className,
    } = props;
    const stepData = useSelector(getPlotStepData);
    const [selectedProfession, setSelectedProfession] = useState<string>(stepData?.action?.initialWork);
    const dispatch = useDispatch();
    const api = useApi();

    const nextStepHandler = (linkOnStep: number) => {
        const user = api.User;
        const currentStep = user.current_scene.plotStep;

        api.EditUser({
            current_scene: {
                plotStep: linkOnStep,
                previousStep: currentStep,
            },
            profession: selectedProfession,
        }).then(() => {
            user.profession = selectedProfession;
            if (selectedProfession === 'unemployed') {
                dispatch(plotStepsActions.addedPlotStepData(plotStepData(52, user)));
            } else {
                dispatch(plotStepsActions.addedPlotStepData(plotStepData(linkOnStep, user)));
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    return (
        <div className={classNames(cls.BlockSelection, {}, [className])}>
            <Wrapper theme={ThemeWrapper.PLOT}>
                <div className={cls.title}>
                    {stepData?.action?.title}
                </div>
                <div className={cls.list}>
                    {stepData?.action?.blocks.map((card: any) => (
                        <div
                            key={card.keyProfession}
                            onClick={() => setSelectedProfession(card.keyProfession)}
                            onKeyDown={(e:KeyboardEvent<HTMLElement>) => e.code === 'Enter' && setSelectedProfession(card.keyProfession)}
                            role="button"
                            tabIndex={0}
                            className={
                                classNames(
                                    cls.card,
                                    {
                                        [cls.cardNotWork]: card.notWork,
                                        [cls.active]: selectedProfession === card.keyProfession,
                                    },
                                    [],
                                )
                            }
                        >
                            {card.notWork
                                ? (
                                    <div className={cls.notWork}>
                                        {card.text}
                                    </div>
                                )
                                : (
                                    <div className={cls.content}>
                                        <div className={cls.top}>
                                            <div className={cls.imgBox}>
                                                <img src={card.icon} alt="Иконка профессии" />
                                            </div>
                                            <div className={cls.info}>
                                                <div className={cls.name}>
                                                    {card.name}
                                                </div>
                                                <div className={cls.cost}>
                                                    <span className={cls.sum}>
                                                        {/* eslint-disable-next-line max-len */}
                                                        {card.sum.toLocaleString('ru-RU', { style: 'currency', currency: 'RUB', minimumFractionDigits: 2 })}
                                                    </span>
                                                    <span className={cls.time}>
                                                        {
                                                            stepData?.action?.perMonth ? ' / мес' : ' / час'
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        {card.duties
                                            && (
                                                <div className={cls.duties}>
                                                    <b>Что делать:</b>
                                                    {' '}
                                                    {card.duties}
                                                </div>
                                            )}
                                    </div>
                                )}
                        </div>
                    ))}
                </div>
                <div className={cls.actionButton}>
                    <Button
                        className={cls.button}
                        theme={ButtonTheme.NEXT}
                        onClick={() => nextStepHandler(stepData?.action?.linkOnStep)}
                    >
                        Выбрать
                    </Button>
                </div>
            </Wrapper>
        </div>
    );
};
